import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
      import {VoiceActionDetail, TextareaFieldType, Attachment} from '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
import {AudioRecordingStatus} from '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';

      export interface Props {
     type?: TextareaFieldType;
     value?: string;
     rejectUpdatesOnFocus?: boolean;
     rejectUpdates?: boolean;
     rejectDuplicateUpdates?: boolean;
     placeholder?: string;
     label?: string;
     errorText?: string;
     maxlength?: number | undefined;
     disabled?: boolean;
     error?: boolean;
     required?: boolean;
     showLabel?: boolean;
     showToolbar?: boolean;
     showVoiceRecording?: boolean;
     hasLeadingIcon?: boolean;
     recording?: boolean;
     recordingDuration?: number;
     audioLevels?: number[];
     recordingStatus?: AudioRecordingStatus;
     playbackPosition?: number;
     attachments?: Attachment[]
   }

      
  
      export type {VoiceActionDetail, TextareaFieldType, Attachment} from '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
export type {AudioRecordingStatus} from '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTextareaField',
  props: {
    type: {},
    value: {},
    rejectUpdatesOnFocus: { type: Boolean },
    rejectUpdates: { type: Boolean },
    rejectDuplicateUpdates: { type: Boolean },
    placeholder: {},
    label: {},
    errorText: {},
    maxlength: {},
    disabled: { type: Boolean },
    error: { type: Boolean },
    required: { type: Boolean },
    showLabel: { type: Boolean },
    showToolbar: { type: Boolean },
    showVoiceRecording: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    recording: { type: Boolean },
    recordingDuration: {},
    audioLevels: {},
    recordingStatus: {},
    playbackPosition: {},
    attachments: {}
  },
  emits: ["change", "input", "blur", "send-click", "add-click", "screenshot-click", "image-click", "attachment-click", "voice-action", "attachment-remove"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: CustomEvent<{value: string}>) => emit('change', event as CustomEvent<{value: string}>),
onInput: (event: CustomEvent<{value: string}>) => emit('input', event as CustomEvent<{value: string}>),
onBlur: (event: CustomEvent<void>) => emit('blur', event as CustomEvent<void>),
onSendClick: (event: CustomEvent<{value: string}>) => emit('send-click', event as CustomEvent<{value: string}>),
onAddClick: (event: CustomEvent<void>) => emit('add-click', event as CustomEvent<void>),
onScreenshotClick: (event: CustomEvent<void>) => emit('screenshot-click', event as CustomEvent<void>),
onImageClick: (event: CustomEvent<void>) => emit('image-click', event as CustomEvent<void>),
onAttachmentClick: (event: CustomEvent<void>) => emit('attachment-click', event as CustomEvent<void>),
onVoiceAction: (event: CustomEvent<VoiceActionDetail>) => emit('voice-action', event as CustomEvent<VoiceActionDetail>),
onAttachmentRemove: (event: CustomEvent<{id: string}>) => emit('attachment-remove', event as CustomEvent<{id: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-textarea-field',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})